import Vue from 'vue';
import Axios from 'axios';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { Plugin } from 'vue-fragment';
import money from 'v-money';
import VModal from 'vue-js-modal';
import VueApollo from 'vue-apollo';
import VuePaginate from 'vue-paginate/dist/vue-paginate';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource/dist/vue-resource';
import VueTheMask from 'vue-the-mask';
import Alert from './components/Alert';
import Loader from './components/Loader';
import PageHeader from './components/PageHeader.vue';
import App from './App.vue';
import Default from './layouts/Default';
import Clean from './layouts/Clean';
import Filters from './filters';
import store from './store';
import router from './router';
import Zilla from './plugins';
import 'material-design-icons/iconfont/material-icons.css';
import '@quero/zilla-icons-fa-fontawesome-pro/css/all.css';
import 'bootstrap-sass/assets/javascripts/bootstrap.js';
import 'bootstrap-sass/assets/stylesheets/_bootstrap.scss';
import './assets/stylesheets/admin.sass';

Vue.use(Filters);
Vue.use(money, { precision: 4 });
Vue.use(VModal, { dialog: true });
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VuePaginate);
Vue.use(VueTheMask);
Vue.use(Alert);
Vue.use(Loader);
Vue.use(Plugin);
Vue.use(VueApollo);
Vue.use(Zilla);

Vue.component('default-layout', Default);
Vue.component('clean-layout', Clean);
Vue.component('page-header', PageHeader);

if (process.env.NODE_ENV === 'production') {
  Vue.prototype.$serverHost = 'https://api.queropago.com.br';
  Vue.prototype.$qpFrontHost = 'https://queropago.com.br';
  Vue.prototype.$slackClientId = '2154556232.804663168528';
} else {
  Vue.prototype.$serverHost = 'http://localhost:5000';
  Vue.prototype.$qpFrontHost = 'http://localhost:8080';
  Vue.prototype.$slackClientId = '2154556232.842937953606';
}

// GraphQL Apollo configuration
const apolloClient = new ApolloClient({
  link: createHttpLink({
    uri: `${Vue.prototype.$serverHost}/admin/graphql`,
    credentials: 'include',
  }),
  cache: new InMemoryCache(),
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

// Axios base url configuration
Axios.defaults.baseURL = Vue.prototype.$serverHost;
Axios.defaults.withCredentials = true;

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App),
}).$mount('#app');
